import React from "react";
import { createBrowserHistory } from "history";
export const clumnData = [
  {
    title: "序号",
    dataIndex: "key",
    key: "key",
    render: (text, record, index) => {
      return <div>{index + 1}</div>;
    },
  },
  {
    title: "日期",
    dataIndex: "createrTime",
    key: "createrTime",
    render: (text, record, index) => {
      return <div>{text ? text.split(" ")[0] : ""}</div>;
    },
  },
  {
    title: "办理单位",
    dataIndex: "orgName",
    key: "orgName",
  },
  {
    title: "办理方式",
    dataIndex: "adviceName",
    key: "adviceName",
  },
  {
    title: "去向",
    dataIndex: "orgDisposeName",
    key: "orgDisposeName",
  },
];
function blobToDataURI(blob, callback) {
  var reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onload = function (e) {
    callback(e.target.result);
  };
}

export const exportSaveData = (data, filename, props) => {
  let blob = new Blob([data], { type: "application/pdf;chartset=UTF-8" });
  let blobUrl = window.URL.createObjectURL(blob);
  props.history.push({
    pathname: "/pdfweb",
    state: {
      pdfData: blobUrl,
    },
  });
  // let open = window.open("about:blank");
  // if (open === null || typeof open === "undefined") {
  //   window.location.href = blobUrl;
  //   return;
  // }
  // setTimeout(() => {
  //   open.location = blobUrl;
  // }, 300);
  // if (window.navigator.msSaveBlob) {
  //   // console.log('ie')
  //   try {
  //     window.navigator.msSaveBlob(blob, filename);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // } else {
  //   // 谷歌浏览器 创建a标签 添加download属性下载
  //   const aElement = document.createElement("a");
  //   document.body.appendChild(aElement);
  //   aElement.style.display = "none";
  //   aElement.href = blobUrl;
  //   aElement.download = filename;
  //   aElement.click();
  //   document.body.removeChild(aElement);
  //   setTimeout(() => {
  //     window.URL.revokeObjectURL(blobUrl); //释放掉blob对
  //   }, 400);
  // }
};
